import { base44 } from '@/api/base44Client';

// The highest version across settings records is authoritative, so record order never matters.
export async function getRequiredLoginVersion() {
  const configs = await base44.entities.AdminConfig.list();
  return configs.reduce((max, c) => Math.max(max, c.required_login_version || 1), 1);
}

// Called right after a successful sign-in: marks this account as current.
export async function stampLoginVersion() {
  const required = await getRequiredLoginVersion();
  localStorage.setItem('device_login_version', String(required));
  await base44.auth.updateMe({ login_version: required });
}

// This device's own stamp — signing in elsewhere never refreshes it.
export const getDeviceLoginVersion = () => Number(localStorage.getItem('device_login_version') || 0);

// Set when we sign someone out for a reset, so whichever sign-in screen they
// use next (login, splash, phone code…) is recognised as a fresh sign-in.
export const markAwaitingRelogin = () => localStorage.setItem('awaiting_relogin', '1');
export const isAwaitingRelogin = () => localStorage.getItem('awaiting_relogin') === '1';
export const clearAwaitingRelogin = () => localStorage.removeItem('awaiting_relogin');

export function signOutForReset(query = 'reset=1') {
  markAwaitingRelogin();
  // Keep customer_data so the basket (basket_<customer id>) is still there after signing back in.
  base44.auth.logout(`/login?${query}`);
}